
import state from "../state"
import Store from "../store"
import moment from "moment";
export default {
    ITEM_ACTID({ commit }, item) {
        commit('ITEM_ACTID', item)
    }, ITEM_ACTNAME({ commit }, item) {
        commit('ACTNAME', item)
    }, ITEM_ITEMLIST({ commit }, item) {
        commit('ITEMLIST', item)
    }, TAHSILAT_DETAY({ commit }, item) {
        commit('TAHSILAT_DETAY', item)
    }, SATINALMA_TUR_ACT({ commit }, item) {
        commit('SATINALMA_TUR', item)
    }, SAT_ROWDATA({ commit }, item) {
        commit('SAT_ROWDATA', item)
    }, KAYITSAYISI_ACT({ commit }, item) {
        commit('KAYITSAYISI_TUT', item)
    }, STOKID_ACT({ commit }, item) {
        commit('STOKID_TUT', item)

    }, STOCKIDALTER_ACT({ commit }, item) {
        commit('STOCKIDALTER_TUT', item)

    }, TAHSILAT_KAYDET({ commit }, val) {
        console.log(val)
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        const today = new Date();
        var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");

        var hdfRECEIPTNO =
            val.ACTID + "-" + moment(String(today)).format("MMDDhhmm");
        var hdfRECEIPTNO2 = moment(String(today)).format("MMDDhhmm");

        if (val.disable == true) {
            var formatli = new Date(Date.parse(val.vade));
            var formatli2 = new Date(Date.parse(today));
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            function dateDiffInDays(a, b) {
                // Discard the time and time-zone information.
                const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
                const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

                return Math.floor((utc2 - utc1) / _MS_PER_DAY);
            }
            // test it
            const a = new Date(formatli2),
                b = new Date(formatli),
                difference = dateDiffInDays(a, b);

            var vadeFormat = moment(String(val.vade)).format("DD.MM.YYYY");
            var banktxt = "";
            var cektxt = "";

            if (typeof val.bankaText == "undefined") {
                banktxt = "";
            } else {
                banktxt = val.bankaText;
            }
            if (typeof val.CekNo == "undefined") {
                cektxt = "";
            } else {
                cektxt = val.CekNo;
            }
            const args = {
                token: Store.state.tokenId,
                ISLEM: val.islemselected,
                ACTID: val.ACTID,
                PERSONELADI: Store.state.USERLONGNAME,
                EMPLOYEEID: Store.state.employeeid,
                INSERTUSERID: Store.state.UserId,

                TRANSDATE: TRANSDATE,
                DESCRIPTION: "Crm Tahsilat",

                TOTAL: val.tutar,
                CSNO: cektxt,
                DUEDATE: vadeFormat,
                DUEDAY: difference,
                NAMEENDORSE: "",
                BANKNAME: banktxt,
                BANKBILLNO: "",
                ITEMID: hdfRECEIPTNO + val.ind,
                ITEM: val.ind + 1,
                RECEIPTNO: hdfRECEIPTNO + "-" + val.ind, //uuid.v4(),
            };

            console.log(args);

            return new Promise((resolve, reject) => {
                soap.createClient(url, function (err, client) {
                    client.INT_TAHSILAT_INS(args, function (err, result) {
                        if (result.INT_TAHSILAT_INSResult == "-1") {
                            Store.dispatch("logout");
                        }
                        try {
                            vm.veriler = JSON.parse(result.INT_TAHSILAT_INSResult);
                            if (vm.veriler.response == "Ok") {
                                
                                resolve("Ok")
                                console.log("Ok")


                            } else {
                                console.log("no")


                            }
                        } catch (error) {
                            console.log("noooo")

                            console.log(error);
                            console.log(result);

                        }
                    });
                });
            })

        }


    }
}